
                import React from 'react';
                import ReactDOM from 'react-dom';
                import App from '/app/src/frontend/apps/VaccinationTool/VaccinationTool';

                const element = document.getElementById('vaccination-tool-root');

                ReactDOM.hydrate(
                    React.createElement(App, { contextPath: element.dataset.contextPath }),
                    element
                );
            


//////////////////
// WEBPACK FOOTER
// ./vaccination-tool.js
// module id = 651
// module chunks = 4